// S28: Password Reset API Endpoints

import { apiClient } from './client';

export interface ForgotPasswordRequest {
  email: string;
}

export interface ForgotPasswordResponse {
  message: string;
}

export interface ValidateTokenResponse {
  valid: boolean;
  message: string;
  email?: string;
  locale_bootstrap?: { // S37: Server-provided locale with source
    locale: string;
    locale_source: string;
  };
}

export interface ResetPasswordRequest {
  token: string;
  password: string;
  password_confirmation: string;
}

export interface ResetPasswordResponse {
  message: string;
  token: string;
  user: {
    id: string;
    email: string;
    full_name: string;
    role: string;
    country: string;
  };
}

// POST /api/password/forgot
export const forgotPassword = async (
  data: ForgotPasswordRequest
): Promise<ForgotPasswordResponse> => {
  const response = await apiClient.post('/api/password/forgot', data);
  return response.data;
};

// GET /api/password/reset?token=xxx
export const validateResetToken = async (
  token: string
): Promise<ValidateTokenResponse> => {
  const response = await apiClient.get('/api/password/reset', {
    params: { token },
  });
  return response.data;
};

// POST /api/password/reset
export const resetPassword = async (
  data: ResetPasswordRequest
): Promise<ResetPasswordResponse> => {
  const response = await apiClient.post('/api/password/reset', data);
  return response.data;
};
